import { isTokensEqual } from './is-tokens-equal';
export function isRateEqual(rate1, rate2) {
    return (rate1.rate === rate2.rate &&
        rate1.revertedRate === rate2.revertedRate &&
        isTokensEqual(rate1.sourceToken, rate2.sourceToken) &&
        isTokensEqual(rate1.destinationToken, rate2.destinationToken));
}
//# sourceMappingURL=is-rate-equal.js.map